<template>
  <a v-if="pageAdInfo.show" v-bind:id="pageAdInfo.divId" href="javascript:;" style="width: 100%;display: block;" @mousedown="getClktkData(0)" @mouseup="getClktkData(1)" @click="clickReport($event, pageAdInfo.url)" target="_blank" class="'touch'" :provider="pageAdInfo.provider">
    <template v-if="pageAdInfo.miniimg_size >= 3 || pageAdInfo.imgType === 3 ">
      <h2 class="news-h2">
        <div class="news-title" v-text="pageAdInfo.topic"></div>
      </h2>
      <div class="news-imgs" :style="(pageAdInfo.adImgType===3) ? 'width:600px;height:200px;' : ''">
        <div class="news-img-a new-div2" v-for="(imgDist, imgIdx) in pageAdInfo.miniimg" v-bind:href="imgDist.url" target="_blank" :style="(pageAdInfo.imgType===3) ? 'width:600px;height:200px;' : ''" v-bind:key="imgIdx">
          <template v-if="pageAdInfo.imgType===3">
            <img class="news-img" v-bind:src="imgDist.src" style="transform: translate(-50%, -50%); width: 600px; height: 200px; transition: all 0.2s linear;" onmouseover="this.style.width='630px';this.style.height='210px';" onmouseout="this.style.width='600px';this.style.height='200px';" />
          </template>
          <template v-else>
            <img class="news-img" v-bind:src="imgDist.src" />
          </template>
        </div>
        <div class="news-img-a placeholder-img new-div2" :href="pageAdInfo.url" target="_blank" v-show="pageAdInfo.showMorePos">查看更多</div>
      </div>
      <div class="news-info clearfix">
        <span class="news-from" v-text="pageAdInfo.source"></span>
        <span class="news-date">广告</span>
      </div>
    </template>
    <template v-else>
      <div class="news-imgs" >
        <template v-if="pageAdInfo.miniimg_size > 0">
          <div class="news-img-a new-div2">
            <img class="news-img" :src="pageAdInfo['miniimg'][0]['src']" />
          </div>
        </template>
      </div>
      <div class="news-content">
        <h2 class="news-h2">
          <div class="news-title" v-text="pageAdInfo.topic"></div>
        </h2>
        <div class="news-info">
          <span class="news-from" v-text="pageAdInfo.source"></span>
          <span class="ad-date" >广告</span>
        </div>
      </div>
    </template>
  </a>
</template>
<script>
import util from '../../api/util';
import stats from '../../api/statistics';
import ad360 from '../../api/ad/ad_360';

export default {
  name: 'NewsTplAd360',
  props: [
    'newsAdInfo', 'compName', 'tag', 'pageType'
  ],
  data () {
    return {
      pageAdInfo: {},
      iframeRect: {
        stop: 0,
        wheight: 0
      }
    }
  },
  mounted () {
    this.pageAdInfo = this.newsAdInfo;
    this.show = true;
    this.clktkData = {};
    this.$bus.$on('showReport', (data) => {
      this.iframeRect = data.rect;
      this.showReport();
    });
  },
  methods: {
    getClktkData (type) {
      if (type) {
        // 鼠标抬起时间戳
        this.clktkData.__EVENT_TIME_END__ = Date.now();
      } else {
        // 鼠标按下时间戳
        this.clktkData.__EVENT_TIME_START__ = Date.now();
      }
    },
    /**
     * 发送展现统计
     */
    showReport () {
      if (util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType) && this.pageAdInfo['show_report_50bang'] !== 'reported') {
        stats.ajax99(this.pageAdInfo.show_report_50bang + (this.pageAdInfo.imgType != 1 ? '_' + this.pageAdInfo.imgType: ''));
        ad360.showReport(this.pageAdInfo.imptk);
        this.pageAdInfo['show_report_50bang'] = 'reported';
      }
    },
    /**
     * 点击统计
     */
    clickReport (event, directUrl) {
      var _this = this;
      if (util.isElementInViewport(this.pageAdInfo.divId, this.iframeRect, this.pageType) && this.pageAdInfo.hasOwnProperty('click_report_50bang')) {
        stats.ajax99(this.pageAdInfo.click_report_50bang + (this.pageAdInfo.imgType != 1 ? '_' + this.pageAdInfo.imgType : ''));
        var clktkTpl = this.pageAdInfo.clktk;
        var clktkUrl = clktkTpl.concat();
        clktkUrl = _this.macroExchange(clktkUrl, this.clktkData, event);
        ad360.showReport(clktkUrl);
      }
      // 跳转
      window.open(_this.getMacroInfo(directUrl, this.clktkData, event));
    },
    /**
     * 宏替换遍历
     */
    macroExchange (arrReportUrls, clktkData, event) {
      var _this = this;
      if (arrReportUrls.length > 0) {
        arrReportUrls.forEach(function (reportUrl, index) {
          arrReportUrls[index] = _this.getMacroInfo(reportUrl, clktkData, event);
        })
      }
      return arrReportUrls;
    },
    /**
     * 宏替换
     */
    getMacroInfo (directUrl, clktkData, event) {
      directUrl = directUrl.replace('__EVENT_TIME_START__', clktkData.__EVENT_TIME_START__);
      directUrl = directUrl.replace('__EVENT_TIME_END__', clktkData.__EVENT_TIME_END__);
      directUrl = directUrl.replace('__OFFSET_X__', event.offsetX);
      directUrl = directUrl.replace('__OFFSET_Y__', event.offsetY);
      return directUrl;
    }
  }
}
</script>
